import React, { useEffect, useState } from 'react'
import { SelectInline, InputInline, SelectAsyncInline } from '@arnsbogroup/react-voicearchive'
import debounce from 'debounce-promise'

const CustomerInfo = ( {customer, onChange} ) => {
  if (!customer) {
    return null
  }

  const [producers, setProducers] = useState([]);

  useEffect(() => {
    fetchAllProducers();
  }, []);

  const fetchAllProducers = () => {
    fetch(`/rest/v2/supplier?search[type]=3`)
      .then((response) => response.json())
      .then((data) => {
        setProducers(data);
      });
  }

  const getPrimaryContactValueOption = () => {
    const contact = customer.contacts.find(contact => contact.uid === customer.defaultcontact);
    return contact ? { value: contact.uid, label: contact.name } : null;
  }

  const getPrimaryContactOptions = () => {
    const filteredContacts = customer.contacts.filter(contact => contact.uid !== customer.cccontact);
    const contacts = filteredContacts.map((value) => ({value: value.uid, label: value.name}));
    return contacts;
  }

  const getSecondaryContactValueOption = () => {
    const contact = customer.contacts.find(contact => contact.uid === customer.cccontact);
    return contact ? { value: contact.uid, label: contact.name } : null;
  }

  const getSecondaryContactOptions = () => {
    const filteredContacts = customer.contacts.filter(contact => contact.uid !== customer.defaultcontact);
    const contacts = filteredContacts.map((value) => ({value: value.uid, label: value.name}));
    return contacts;
  }

  const getPrimaryProducerValueOption = () => {
    const producer = producers.find(producer => producer.uid === customer.primary_producer_uid);
    return producer ? { value: producer.uid, label: producer.userid } : null;
  }

  const getPrimaryProducerOptions = () => {
    const filteredProducers = producers.filter(producer => producer.uid !== customer.secondary_producer_uid);
    const producerOptions = filteredProducers.map((value) => ({value: value.uid, label: value.userid}));
    return producerOptions;
  }
  
  const getSecondaryProducerValueOption = () => {
    const producer = producers.find(producer => producer.uid === customer.secondary_producer_uid);
    return producer ? { value: producer.uid, label: producer.userid } : null;
  }

  const getSecondaryProducerOptions = () => {
    const filteredProducers = producers.filter(producer => producer.uid !== customer.primary_producer_uid);
    const producerOptions = filteredProducers.map((value) => ({value: value.uid, label: value.userid}));
    return producerOptions;
  }

  return (
    <div className="p-4 text-center">
      <div className="ml-2 grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3 flex-initial w-full text-left order-3 md:order-none">
        <div className="flex space-y-4">
          <div className="flex-initial space-y-2">
            <InputInline 
              labelClassName="text-xs"
              label="Company Name"
              placeholder="Company Name"
              disabled={customer.crmIsMaster}
              value={ customer.name }
              onChange={({ target: { value } }) => {
                onChange({ ...customer, name: value })
              }}
            />

            <SelectInline
              labelClassName="text-xs"
              label="Primary contact"
              placeholder="Primary contact"
              noDataLabel="No primary contact"
              disabled={customer.crmIsMaster}
              isClearable
              value={ getPrimaryContactValueOption() }
              options={ getPrimaryContactOptions() }
              onChange={(selection) => { onChange({ ...customer, defaultcontact: (selection) ? selection.value : 0 }) } } 
            />

            <SelectInline
              labelClassName="text-xs"
              label="Secondary contact"
              placeholder="Secondary contact"
              noDataLabel="No secondary contact"
              disabled={customer.crmIsMaster}
              isClearable
              value={ getSecondaryContactValueOption() }
              options={ getSecondaryContactOptions() }
              onChange={(selection) => { onChange({ ...customer, cccontact: (selection) ? selection.value : 0 }) } } 
            />
          </div>
        </div>
        <div className="flex space-y-4">
            <div className="flex-initial space-y-2">
              <SelectInline
                labelClassName="text-xs"
                label="Primary producer"
                placeholder="Primary producer"
                noDataLabel="No primary producer"
                isClearable
                value={ getPrimaryProducerValueOption() }
                options={ getPrimaryProducerOptions() }
                onChange={(selection) => {
                   onChange({ ...customer, primary_producer_uid: (selection) ? selection.value : 0 }) } } 
              />

              <SelectInline
                labelClassName="text-xs"
                label="Secondary producer"
                placeholder="Secondary producer"
                noDataLabel="No secondary producer"
                isClearable
                value={ getSecondaryProducerValueOption() }
                options={ getSecondaryProducerOptions() }
                onChange={(selection) => { onChange({ ...customer, secondary_producer_uid: (selection) ? selection.value : 0 }) } } 
              />
          </div>
        </div>

        <div className="flex space-y-4">
            <div className="flex-initial space-y-2">
              <SelectAsyncInline
                value={customer.primary_coordinator.name ? { value: customer.primary_coordinator.uid, label: customer.primary_coordinator.name } : null}
                onChange={(selection) => {
                  onChange({ ...customer, primary_coordinator_uid: (selection) ? selection.value : 0 })
                }}
                options={[]}
                label="Primary coordinator"
                placeholder="Primary coordinator"
                noDataLabel="No primary coordinator"
                noOptionsMessage={({ inputValue }) => (inputValue) ? `No coordinator found for '${inputValue}'` : 'No coordinator found'}
                loadingMessage={({ inputValue }) => `Searching for '${inputValue}'..`}
                cacheOptions
                defaultOptions
                isClearable
                loadOptions={
                  debounce((query) => fetch(`/rest/v1/coordinator?search[name]=${query}`)
                    .then((response) => response.json())
                    .then((producers) => producers.map(({ uid, name }) => ({ value: uid, label: name })))
                  , 250)
                }
              />

              <SelectAsyncInline
                value={customer.secondary_coordinator.name ? { value: customer.secondary_coordinator.uid, label: customer.secondary_coordinator.name } : null}
                onChange={(selection) => {
                  onChange({ ...customer, secondary_coordinator_uid: (selection) ? selection.value : 0 })
                }}
                options={[]}
                label="Secondary coordinator"
                placeholder="Secondary coordinator"
                noDataLabel="No secondary coordinator"
                noOptionsMessage={({ inputValue }) => (inputValue) ? `No coordinator found for '${inputValue}'` : 'No coordinator found'}
                loadingMessage={({ inputValue }) => `Searching for '${inputValue}'..`}
                cacheOptions
                defaultOptions
                isClearable
                loadOptions={
                  debounce((query) => fetch(`/rest/v1/coordinator?search[name]=${query}`)
                    .then((response) => response.json())
                    .then((producers) => producers.map(({ uid, name }) => ({ value: uid, label: name })))
                  , 250)
                }
              />
            </div>
        </div>
      </div>
    </div>
  )
}

export default CustomerInfo
